module.exports = __webpack_public_path__ + "img/TV_Adverts.41d71e00.jpg";